<template>
  <div class="my-1">
    <div v-if="question.type == 'CHECKBOX'" class="row">
      <div class="col">
        <div class="form-check">
          <input
            class="form-check-input"
            :class="{'is-invalid': questionResponseError}"
            type="checkbox"
            :disabled="inputDisabled"
            :id="$id('question' + question.id)"
            :ref="'question' + question.id"
            v-model="givenResponse.response"
            true-value="1" false-value="0">
          <label class="form-check-label font-weight-bold" :for="$id('question' + question.id)" >
            {{ question.question }} <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
          </label>
        </div>
      </div>
      <hr/>
    </div>
    <div v-else-if="question.type == 'RADIO'" class="row">
      <div class="col">
        <p class="h5 font-weight-bold">{{ question.question }} <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup></p>
        <div v-for="(answer, key) in question.answer_options" class="form-check" :key="key" :class="{'is-invalid': questionResponseError}">
          <input
            class="form-check-input"
            :class="{'is-invalid': questionResponseError}"
            type="radio"
            :disabled="inputDisabled"
            :id="$id('answer' + key)"
            :ref="'question' + question.id"
            v-model="givenResponse.response"
            :value="answer"
            :required="question.required">
          <label class="form-check-label" :for="$id('answer' + key)">
            {{ answer }}
          </label>
        </div>
      </div>
      <hr/>
    </div>
    <div v-else-if="question.type == 'DROPDOWN'" class="form-group row">
      <label :for="$id('question' + question.id)" class="col-sm-6 col-form-label font-weight-bold">
        {{ question.question }} <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
      </label>
      <div class="col-sm-6">
        <select
          v-model="givenResponse.response"
          :disabled="inputDisabled"
          class="form-control"
          :class="{'is-invalid': questionResponseError}"
          :ref="'question' + question.id"
          :required="question.required">
          <option :value="null">&lt;-- SELECT --&gt;</option>
          <option v-for="answer in question.answer_options" :id="$id('question' + question.id)" :value="answer">{{ answer }}</option>
        </select>
      </div>
      <hr/>
    </div>
    <div v-else-if="question.type == 'FREETEXT'" class="form-group row">
      <label :for="$id('question' + question.id)" class="col-sm-6 col-form-label font-weight-bold">
        {{ question.question }} <sup v-if="question.required" class="text-red" data-toggle="tooltip" title="Required">(*)</sup>
      </label>
      <div class="col-sm-6">
        <debounce-input
          tag="textarea"
          v-model="givenResponse.response"
          :disabled="inputDisabled"
          :delay="1000"
          class="form-control"
          :class="{'is-invalid': questionResponseError}"
          rows="4"
          :required="question.required"></debounce-input>
      </div>
      <hr/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cart: {
      type: Object,
    },
    cartItem: {
      type: Object,
    },
    sale: {
      type: Object,
    },
    saleItem: {
      type: Object,
    },
    question: {
      type: Object,
    },
    questionResponse: {
      type: Object,
    },
  },

  data() {
    return {
      givenResponse: JSON.parse(JSON.stringify(this.questionResponse)),
      inputDisabled: false,
    };
  },

  model: {
    event: 'change',
    prop: 'questionResponse'
  },

  computed: {
    questionResponseError() {
      let error = false;
      if (this.question.required == 1) {
        if (this.question.type == 'CHECKBOX') {
          if (this.givenResponse.response == 0 || this.givenResponse.response === null) {
            error = true;
          }
        } else if (this.question.type == 'RADIO' && this.givenResponse.response === null) {
          error = true;
        } else if (this.givenResponse.response == '' || this.givenResponse.response == null) {
          error = true;
        }
      }
      return error;
    },
  },

  watch: {
    givenResponse: {
      deep: true,
      handler(newValue, oldValue) {
        // console.log('QuestionResponse:handler', newValue, oldValue);
        if (newValue.response != this.questionResponse.response) {
          if (this.questionResponse.created_at) {
            this.updateResponse(newValue);
          } else {
            this.createResponse(newValue);
          }
        }
      },
    }
  },

  methods: {
    createResponse(questionResponse) {
      // console.log('QuestionResponse:createResponse', questionResponse, questionResponse.questionable_id);

      this.inputDisabled = true;

      let route;
      let routeParameter;
      if (this.cart) {
        route = 'api.cart.question-responses.store';
        routeParameter = this.cart;
      } else if (this.sale) {
        route = 'api.sale.question-responses.store';
        routeParameter = this.sale;
      } else if (this.cartItem) {
        route = 'api.cart-item.question-responses.store';
        routeParameter = this.cartItem;
      } else if (this.saleItem) {
        route = 'api.sale-item.question-responses.store';
        routeParameter = this.saleItem;
      } else {
        flash('Obtaining route error', 'danger');
        return false;
      }

      // console.log('about to Axios', route, routeParameter);

      axios.post(this.route(route, routeParameter), questionResponse)
        .then((response) => {
          if (response.status == 200) {
            // console.log('axios of createResponse() in QuestionResponse', response.data);

            this.givenResponse = response.data;
            this.$emit('change', JSON.parse(JSON.stringify(response.data)));

            this.inputDisabled = false;
          } else {
            flash('Error on createResponse', 'danger');
            console.log('createResponse', response.data);
            console.log('createResponse', response.status);
            console.log('createResponse', response.statusText);
          }

          flash('Response Created', 'success');
          // this.loading(false);
        })
        .catch((error) => {
          flash('Error in createResponse for ' + this.report, 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            // else if HTTP_CONFLICT
            // else if HTTP_FORBIDDEN on enough permissions
            if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('createResponse:401', error.response.data);
            }
            console.log('createResponse: Response error', error.response.data, error.response.status, error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('createResponse: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('createResponse: Error', error.message);
          }

          // this.loading(false);
          this.inputDisabled = false;
        });
    }, // createResponse()

   updateResponse(questionResponse) {
      // console.log('QuestionResponse:updateResponse', questionResponse, questionResponse.questionable_id);

      if (questionResponse.questionable && questionResponse.questionable.type != 'FREETEXT') {
        this.inputDisabled = true;
      }

      let route;
      if (this.cart) {
        route = 'api.cart-question-responses.update';
      } else if (this.sale) {
        route = 'api.sale-question-responses.update';
      } else if (this.cartItem) {
        route = 'api.cart-item-question-responses.update';
      } else if (this.saleItem) {
        route = 'api.sale-item-question-responses.update';
      } else {
        flash('Error obtaining route', 'danger');
        return false;
      }

      // console.log('route', route);

      if (questionResponse.id) {
        // TODO: to protect from people clicking too quickly, but this may miss changes and the customer sees wrong inputs

        axios.patch(this.route(route, questionResponse), questionResponse)
          .then((response) => {
            if (response.status == 200) {
              // console.log('axios of updateResponse() in QuestionResponse', response.data);

              this.givenResponse = response.data;
              this.$emit('change', JSON.parse(JSON.stringify(response.data)));

              if (questionResponse.questionable && questionResponse.questionable.type != 'FREETEXT') {
                this.inputDisabled = false;
              }

            } else {
              flash('Error on updateResponse', 'danger');
              console.log('updateResponse', response.data);
              console.log('updateResponse', response.status);
              console.log('updateResponse', response.statusText);
            }

            flash('Response Updated', 'success');
            // this.loading(false);
          })
          .catch((error) => {
            flash('Error in updateResponse for ' + this.report, 'danger');
            if (error.response) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              // else if HTTP_CONFLICT
              // else if HTTP_FORBIDDEN on enough permissions
              if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('updateResponse:401', error.response.data);
              }
              console.log('updateResponse: Response error', error.response.data, error.response.status, error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('updateResponse: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('updateResponse: Error', error.message);
            }

            // this.loading(false);
          });
      }
    }, // updateResponse()

  },

  mounted() {

  },
}
</script>
